import React, { useEffect } from "reactn";
import { Grid, makeStyles } from "@material-ui/core";
import notFoundIllustration from "../../../assets/img/RevisedIllustration.webp";

const useStyles = makeStyles(theme => ({
  container: {
    margin: "3em 0"
  },
  illustration: {
    width: "200px",
    marginBottom: "1em"
  },
  messageText: {
    fontFamily: "Montserrat, sans-serif !important",
    color: "#505050 !important"
  }
}));

const NoDataAvailable = ({ message }) => {
  const { container, illustration, messageText } = useStyles();

  if (document.getElementById("parent-background"))
    document.getElementById("parent-background").style.background = "#FAFAFA";

  useEffect(() => {
    return () => {
      if (document.getElementById("parent-background"))
        document.getElementById("parent-background").style.background = "#FFF";
    };
  }, []);

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      className={container}
    >
      <img src={notFoundIllustration} className={illustration} alt="No Data" />
      <h3 className={messageText}>{message}</h3>
    </Grid>
  );
};

export default NoDataAvailable;
